import clsx from 'clsx/lite';
import { forwardRef } from 'react';

type SectionProps = React.PropsWithChildren & {
  title: string;
  testId: string;
  showDivider?: boolean;
  className?: string;
  id?: string;
};

const Section = forwardRef<HTMLDivElement, SectionProps>(({ title, children, testId, showDivider = true, className, id }, ref) => (
  <>
    <div ref={ref} className="flex flex-col gap-y-4" data-cy={testId} {...(id ? { id } : {})}>
      <h2 className="text-base font-medium uppercase text-neutral-lighter lg:text-lg">{title}</h2>
      <div className={clsx('text-neutral-darker', className)}>{children}</div>
    </div>
    {showDivider && <hr />}
  </>
));

Section.displayName = 'Section';

export default Section;
